import * as yup from "yup";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FaCircleNotch } from "react-icons/fa";
import { IoSaveOutline } from "react-icons/io5";
import { useState } from "react";

import Datepicker from "../../../components/common/Datepicker";
import Textarea from "./../../../components/common/Textarea";

import complianceService from "../../../services/complianceService";
import moment from "moment";
import Toaster from "./../../../components/common/Toaster";

const schema = yup.object({
  cancellation_date: yup.string().required("Please select cancellation date."),
  cancellation_reason: yup.string(),
});

const CorCancelForm = ({ data, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [dateToday] = useState(
    Date.parse(moment(new Date(), "MM-DD-yyyy").toISOString())
  );

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (info) => {
    try {
      setIsLoading(true);

      const cor = { ...info };
      cor["id"] = data.id;

      await complianceService.cancelCORAsync(cor);

      const item = { ...data };
      item["status_value"] = 0;

      item["status_type"] = (
        <div className="flex items-center">
          <div className="rounded-full h-2 w-2 flex items-center bg-gray-400 justify-center" />
          <span className="ml-3">Inactive</span>
        </div>
      );

      onSuccess(item);
      setIsLoading(false);

      Toaster.Success("COR Cancelled Successfully!");
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textarea
            id="cancellation-reason-textarea"
            name="cancellation_reason"
            title="Reason"
            placeholder="Say something..."
            register={register("cancellation_reason")}
            errors={errors}
            rows={6}
            optional
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Datepicker
            id="cancellation-datepicker"
            name="cancellation_date"
            title="Cancellation Date"
            dateFormat="MM-DD-yyyy"
            timeFormat={false}
            setValue={setValue}
            initialValue={dateToday}
            clearErrors={clearErrors}
            register={register("cancellation_date")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default CorCancelForm;
